// @flow

import type { EmployeePositionsState } from "./types";

export const onGetSharedEmployeePositionsSuccess = (state: EmployeePositionsState) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  list: payload,
});

export const onGetSharedEmployeePositionsError = (state: EmployeePositionsState) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload,
});
